import intermind from '../../../index';
import { Quota, QuotaUsage, UpdateQuotaUsageParams } from '../../../types';

export class AdminQuotaResource {
  async list(): Promise<Quota[]> {
    const { data } = await intermind.httpClient.get<Quota[]>('/admin/quotas');
    return data;
  }

  async listByUserId(userId: string): Promise<QuotaUsage[]> {
    const { data } = await intermind.httpClient.get<QuotaUsage[]>(`/admin/users/${userId}/quotas`);
    return data;
  }

  async updateQuota(quotaId: string, limit: number): Promise<void> {
    await intermind.httpClient.patch(`/admin/quotas/${quotaId}`, { limit });
  }

  async updateQuotaUsage(quotaUsageId: string, params: UpdateQuotaUsageParams): Promise<void> {
    await intermind.httpClient.patch(`/admin/quota-usages/${quotaUsageId}`, params);
  }
}
